export default __webpack_public_path__ + "static/media/Rectangle_yellow_2.5195a296.png";